/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vaccination } from '../../models/vaccination';

export interface DeleteVaccination$Params {
  vaccinationId: number;
}

export function deleteVaccination(http: HttpClient, rootUrl: string, params: DeleteVaccination$Params, context?: HttpContext): Observable<StrictHttpResponse<Vaccination>> {
  const rb = new RequestBuilder(rootUrl, deleteVaccination.PATH, 'delete');
  if (params) {
    rb.path('vaccinationId', params.vaccinationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vaccination>;
    })
  );
}

deleteVaccination.PATH = '/api/vaccination/{vaccinationId}';
